import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import numeral from 'numeral'

interface ShiftCustomSoufflingState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    souffling_list: any[];
    shift_souffling_list: any[];
    plan_list: any[];
    schemas: any;
}

const state: ShiftCustomSoufflingState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    souffling_list: [],
    shift_souffling_list: [],
    plan_list: [],
    schemas: {}
};

const initState: any = cloneDeep(state);

const GET_PLAN_LINES_LIST = 'GET_PLAN_LINES_LIST';
const GET_LINES_SOUFFLING_LIST = 'GET_LINES_SOUFFLING_LIST';
const GET_SHIFT_SOUFFLING_LIST = 'GET_SHIFT_SOUFFLING_LIST';

const mapper: any = {
  '[[рецепт.кол-воды]]': (data: any) => {
    const _temp = parseFloat(data.temp)
    const borders = (data.water_borders && data.water_borders.borders ? data.water_borders.borders : []).filter((item: any, idx: number) => {
      return item.temp < _temp;
    });
    const coef = borders.length ? borders[borders.length - 1].coef : 0

    return numeral((parseFloat(data.water) / coef + data.plus_water) / 1000).format('0.00')
  }
}
const format_text = (text: any, data: any) => {
  const _t = {text: text}
  Object.keys(mapper).map((key: any) => {
    if (_t.text.indexOf(key) > -1) {
      _t.text = _t.text.replace(key, mapper[key](data))
    }
  })
  return _t.text
}

export const actions: ActionTree<ShiftCustomSoufflingState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },
    loadPlans({ commit }, { documentId }) {
      const vm = (this as any)._vm;

      commit('START_LOADING');

      state.documentId = documentId;

      return new Promise((resolve, reject) => {
        vm.$db([
          vm.$q(GET_PLAN_LINES_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'scp.id',
                  shift_id: 'sfpc.shift_id',
                  line_id:  {$case: [
                    [
                      {$null: ['scp.line_id']},
                      'wash_line.id'
                    ],
                    [
                      {$: true},
                      'scp.line_id'
                    ]
                  ]},
                  number: 'sfpc.number',
                  base_name: {
                    $case: [
                      [
                        {$null: ['p.name']},
                        {$: 'Мойка'},
                      ],
                      [
                        {
                          "$": true
                        },
                        'p.name'
                      ]
                    ]
                  },
                  fact_id: 'scf.id',
                  wash_id: 'spw.id',
                  clear_filling: 'spw.clear_filling',
                  is_done: {$case: [
                    [
                      {$null: ['scp.id']},
                      'spw.is_done'
                    ],
                    [
                      {$: true},
                      'scp.is_done'
                    ]
                  ]},
                  done_time: {$case: [
                    [
                      {$null: ['scp.id']},
                      'spw.done_time'
                    ],
                    [
                      {$: true},
                      'scp.done_time'
                    ]
                  ]},
                },
                from: 's:shift_full_plan_custom',
                from_as: 'sfpc',
                joins: [
                  {
                    join: 's:shift_custom_plan',
                    type: 'left',
                    as:   'scp',
                    on: {
                      $and: [
                        {$eq: ['sfpc.plan_id', 'scp.id']},
                        // {$null: ['spv.deleted_at']}
                      ]
                    }
                  },
                  {
                    join: 's:shift_custom_fact',
                    type: 'left',
                    as:   'scf',
                    on: {
                      $and: [
                        {$eq: ['scf.plan_id', 'scp.id']},
                        // {$null: ['spv.deleted_at']}
                      ]
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['scp.product_id', 'p.id']
                    }
                  },
                  {
                    join: 's:shift_plan_washing',
                    type: 'left',
                    as:   'spw',
                    on: {
                      $eq: ['sfpc.wash_id', 'spw.id']
                    }
                  },
                  {
                    join: 's:voc_volumes_washings',
                    type: 'left',
                    as:   'vvw',
                    on: {
                      $and: [
                        {$eq: ['vvw.id', 'spw.washing_id']},
                      ]
                    }
                  },
                  {
                    join: {
                      columns: {
                        id: 'vl.id',
                      },
                      from: 's:voc_lines',
                      from_as: 'vl',
                      where: {
                        $eq: [`vl.templates`, {$: 'wash'}]
                      },
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'wash_line',
                    on: { $eq: ['sfpc.wash_id', 'spw.id'] }
                  },
                  {
                    join: 's:voc_volumes',
                    type: 'left',
                    as:   'vv',
                    on: {
                      $and: [
                        {$eq: ['vv.id', 'vvw.volume_id']},
                      ]
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['sfpc.id']}
                ],
                where:
                  {$or: [
                    {$eq: [`sfpc.shift_id`, {$: documentId}]},
                  ]},
              }),
        ]).then((result: ServerResult) => {
          const opPlanListResult = result.getOperation(GET_PLAN_LINES_LIST);

          const groupsByNumber = opPlanListResult.getContent().documents.reduce((prev: any, item: any) => {
            if (item.number) {
              const _key = item.number.split('.')[0] + '-' + item.shift_id;
              if (!prev[_key]) {
                prev[_key] = []
              }
              prev[_key].push(item.id)
            }
            return prev
          }, {})

          const planList = opPlanListResult.getContent().documents.map((item: any) => {
            const _key = item.number.split('.')[0] + '-' + item.shift_id;
            item.plans = groupsByNumber[_key];
            return item;
          }).filter((item: any) => {
            return item.number.split('.').length == 1
          })
          state.plan_list = planList;
          resolve(null);
        })
      })
    },

    loadData({ commit, getters, dispatch, state }, { documentId, lineId, equipmentId, types }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
      commit('START_LOADING');

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q('SCHEMA_SFV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_fact_vdp`
                }),
            vm.$q('SCHEMA_SJV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_journal_vdp`
                }),
            vm.$q(GET_LINES_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'vls.id',
                  text: 'vls.text',
                  equipment_id: 'vls.equipment_id',
                  with_button: 'vls.with_button',
                  button_label: 'vls.button_label',
                  field_taget: 'vlsf.target',
                  field_type: 'vlsf.type',
                  field_label: 'vlsf.label',
                  field_id: 'vlsf.id',
                },
                from: 's:voc_lines_souffling',
                from_as: 'vls',
                joins: [
                  {
                    join: 's:voc_lines_souffling_fields',
                    type: 'left',
                    as:   'vlsf',
                    on: {
                      $eq: ['vls.field_id', 'vlsf.id']
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['vls.position']},
                  {$asc: ['vls.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`vls.line_id`, {$: lineId}]},
                    ...(equipmentId ? [{$eq: [`vls.equipment_id`, {$: equipmentId}]}] : []),
                    {$in: [`vls.type`, {$: types}]},
                  ]
                }
              }),

            vm.$q(GET_SHIFT_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'ss.id',
                  souffling_id: 'ss.souffling_id',
                  shift_plan_id: 'ss.shift_custom_plan_id',
                  is_accepted: 'ss.is_accepted',
                  manager_name: 'employee.name',
                  updated_at: 'ss.updated_at',
                },
                from: 's:shift_souffling',
                from_as: 'ss',
                joins: [
                  {
                    join: 's:employees',
                    type: 'left',
                    as:   'employee',
                    on: {
                      $eq: ['employee.id', 'ss.manager_id']
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['ss.id']}
                ],
                where: {
                  $or: [
                    {$eq: [`ss.shift_id`, {$: documentId}]},
                  ],
                }
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_LINES_SOUFFLING_LIST);
            const opListResult = result.getOperation(GET_SHIFT_SOUFFLING_LIST);

            if (!opRelResult.hasError() && !opRelResult.hasError()) {
              state.shift_souffling_list = opListResult.getContent().documents
              state.schemas.shift_fact_vdp = result.getOperation('SCHEMA_SFV').getContent().schema
              state.schemas.shift_journal_vdp = result.getOperation('SCHEMA_SJV').getContent().schema

              const shift_souffling: any = {}
              state.shift_souffling_list.map((item: any) => {
                if (!shift_souffling[item.shift_plan_id]) {
                  shift_souffling[item.shift_plan_id] = {}
                }
                shift_souffling[item.shift_plan_id][item.souffling_id] = item
              })
              state.souffling_list = state.plan_list.reduce((prev: any, plan: any) => {
                prev[plan.id] = opRelResult.getContent().documents.map((item: any) => {
                  const _new_item = cloneDeep(item)
                  _new_item.text = format_text(_new_item.text, plan.fields)
                  if (shift_souffling[plan.id] && shift_souffling[plan.id][_new_item.id]) {
                    _new_item.shift_souffling = shift_souffling[plan.id][_new_item.id]
                  }
                  _new_item.shift_plan_id = plan.id
                  _new_item.plans = plan.plans
                  _new_item.value = null
                  return cloneDeep(_new_item)
                })
                return prev
              }, {})
            }
            resolve(null);
            commit('LOADED_SUCCESS');
          });
        })
    },

    setAccepted({state, dispatch, commit, rootState}, {documentId, item}) {
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        commit('START_LOADING');
        let saveQuery = null;
        if (item.shift_souffling) {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .update(item.shift_souffling.id, {
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        } else {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .create('s:shift_souffling', {
                  shift_id: documentId,
                  souffling_id: item.id,
                  shift_custom_plan_id: item.shift_plan_id,
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        }
        const queries = [
          saveQuery
        ]

        if (item.field_id) {
          item.plans.map((plan_id: any) => {
            queries.push(
              vm.$q("SET_SOUFFLINGVALUE-"+plan_id)
                .raw('set_soufling_value')
                .action({
                  field_id: item.field_id,
                  shift_plan_id: plan_id,
                  shift_id: documentId,
                  value: item.value
                })
            )
          })
        }

        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })
    },

    setDone({state, commit}, {plan, clear_filling}) {
      console.log(plan)
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        let done_time = plan.frozen_time ? moment(plan.frozen_time) : moment();

        if (plan.ignore_done_delay) {
          done_time = done_time.add(plan.done_delay.secs, 'seconds');
        }

        const done_fields: any = {
          is_done: true,
          done_time: done_time.utc().local().format('YYYY-MM-DD HH:mm:ss')
        };
        // clear_filling — колонка shift_plan_washing: только для строк мойки
        if (!plan.id) {
          done_fields.clear_filling = clear_filling !== false;
        }
        const queries: any[] = [
          vm.$q('SHIFT_DATA_SAVE')
                .update(plan.id ? plan.id : plan.wash_id, done_fields)
        ];
        commit('START_LOADING');
        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })

    },

    setItemValue({state, commit}, {plan_id, index, newValue}) {
      commit('SET_ITEM_VALUE', {plan_id, index, newValue})
    }
};

export const mutations: MutationTree<ShiftCustomSoufflingState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_ITEM_VALUE: (state, {plan_id, index, newValue}) => {
    console.log('SET_ITEM_VALUE', state.souffling_list[plan_id], plan_id, index, newValue)
    state.souffling_list[plan_id][index].value = newValue
  }
};

export const getters: GetterTree<ShiftCustomSoufflingState, RootState> = {
  shift_souffling_list: (state: ShiftCustomSoufflingState) => {
    const shift_souffling: any = {}
    state.shift_souffling_list.map((item: any) => {
      shift_souffling[item.souffling_id] = item
    })

    return state.souffling_list.map((item: any) => {
      if (shift_souffling[item.id]) {
        item.shift_souffling = shift_souffling[item.id]
      }
      return item
    })
  }
};

export const STORE_KEY = '$_shift_custom_souffling_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
